export enum SELECT_ADDRESS_TRANSITIONS {
  ADDRESSABLE = 'ADDRESSABLE',
  FETCH_ADDRESSES = 'FETCH_ADDRESSES',
  FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS',
  SELECT_SHIPPING_ADDRESS = 'SELECT_SHIPPING_ADDRESS',
  SELECT_BILLING_ADDRESS = 'SELECT_BILLING_ADDRESS',
  CREATE_ADDRESS = 'CREATE_ADDRESS',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
  SELECT_BILLING_EQUAL_SHIPPING_ADDRESS = 'SELECT_BILLING_EQUAL_SHIPPING_ADDRESS',
  SET_DELIVERY_INFOS = 'SET_DELIVERY_INFOS',
}
